import { ActionIcon, Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import * as Sentry from '@sentry/react';
import { IconLink } from '@tabler/icons-react';

export function CopyLinkButton() {
  const handleClick = () => {
    navigator.clipboard.writeText(window.location.href);
    notifications.show({
      title: 'URL copied',
      message: 'Chart URL has been copied to clipboard',
      color: 'green',
    });
    Sentry.logger.info('User copied chart link', { url: window.location.href });
  };

  return (
    <>
      <ActionIcon variant="subtle" color="gray" size="lg" onClick={handleClick} aria-label="Copy link" hiddenFrom="sm">
        <IconLink size={18} />
      </ActionIcon>
      <Button
        variant="subtle"
        color="gray"
        size="compact-sm"
        onClick={handleClick}
        leftSection={<IconLink size={16} />}
        visibleFrom="sm"
      >
        Copy link
      </Button>
    </>
  );
}
